import { NgZone } from '@angular/core';
import { DevicesRouterStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { RouteGroupRule } from '@rocksoft/shared';
import { lastValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';
import { DeviceScheduledTasksStoreActions } from '../sub-features/device-sync/device-scheduled-tasks-store';

/**
 * Creates route group rules for the Device Task Management hub
 */
export function createDeviceTaskManagementRules(store: Store, zone: NgZone): RouteGroupRule[] {
  return [
    // Apple device route - handles scheduled task queue updates
    {
      name: 'device-task-management-group',
      urlPattern: /^\/devices\/brands\/[^/]+\/locations\/[^/]+\/apple\/[^/]+/, // (/devices/brands/:brandId/locations/:locationId/apple/:udid)
      hub: 'device-task-management',
      groupName: async (store) => {
        const udid = await lastValueFrom(store.select(DevicesRouterStoreSelectors.selectUdid).pipe(take(1)));
        if (!udid) return null;
        return udid;
      },
      eventHandlers: [
        {
          eventName: 'RefreshTaskQueue',
          handler: (udid: string) => {
            zone.run(() => {
              store.dispatch(DeviceScheduledTasksStoreActions.SignalRActions.scheduledTasksUpdated({ udid }));
            });
          },
        },
      ],
    },
  ];
}
